class PaginationData {
    total = 0;
    pageNum = 0;
    pageNumber = 1;
    pageSize = 0;
    size = 0;
    startRow = 0;
    endRow = 0;
    pages = 0;
    prePage = 0;
    nextPage = 0;
    hasNextPage = false;
    hasPreviousPage = false;
    constructor(data) {
        if (data) {
            Object.assign(this, data);
        }
    }
}
export default PaginationData;
